import { AccountView } from '@/types/entity-types';
import { isInvestmentAccount } from '@/utils/accounts/is-investment-account';
import { isModulrAccount } from '@/utils/accounts/is-modulr-account';
import { canInitiateInternalPayments } from '../../utils/capability-checks';

type GetEligibleSourceAccountsProps = {
  accounts: AccountView[];
  destinationAccountId?: string;
};

export const getEligibleSourceAccounts = ({ accounts, destinationAccountId }: GetEligibleSourceAccountsProps) => {
  const accountsThatCanInitiateInternalPayments = accounts.filter(canInitiateInternalPayments);

  if (!destinationAccountId) {
    return accountsThatCanInitiateInternalPayments;
  }

  const destinationAccount = accounts.find((account) => account.id === destinationAccountId);

  if (!destinationAccount) {
    return accountsThatCanInitiateInternalPayments;
  }

  const isDestinationAccountInvestment = isInvestmentAccount(destinationAccount);

  const accountsWithSameCurrency = accountsThatCanInitiateInternalPayments.filter(
    (a) => a.currency === destinationAccount.currency,
  );

  if (isDestinationAccountInvestment) {
    return accountsWithSameCurrency.filter(isModulrAccount);
  }

  return accountsWithSameCurrency.filter((a) => a.id !== destinationAccountId);
};
